import { reduxForm } from 'redux-form';
import ResetPasswordContainer from './ResetPasswordContainer';
import ResetPasswordValidator from '../../common/validation/ResetPasswordValidator';

const config = {
  form: 'resetPassword',
  destroyOnUnmount: true,
  validate: ResetPasswordValidator,
  initialValues: {
    password: '',
    confirmPassword: ''
  }
};

const ResetPasswordFormContainer = reduxForm(config)(ResetPasswordContainer);

export default ResetPasswordFormContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ResetPasswordFormContainer.js
 **/